/**
 * state of the shop
 */
const state = {
    id: null,
    stagename: null,
    access_token: null,
    avatar: null,
    studio: false,
    admin: false,
    counter: false,
    support: false,
    receptionist: false,
    monitor: false
}

/**
 * values computed based on state
 */
const getters = {
    isLoggedIn: state => state.access_token,
    isResepcionist: state => state.receptionist,
    isAdmin: state => state.admin,
    isCounter: state => state.counter,
    isMonitor: state => state.monitor,
    isSupport: state => state.support
}

/**
 * mutations that are async
 */
const actions = {

}

/**
 * methods that change the state
 */
const mutations = {
    accessToken: function (state, token) {
        state.access_token = token

        //  save it in local storage also
        localStorage.setItem('token', token)
    },

    updateUser: function (state, payload) {
        console.log(payload)
        state.stagename = payload.stagename
        state.avatar = payload.profile_picture
        state.id = payload.id
        if (payload.admin_flag === 1) {
            state.admin = true
        }
        if (payload.support_flag === 1) {
            state.support = true
        }
        if (payload.counter_flag === 1) {
            state.counter = true
        }
        if (payload.receptionist_flag === 1) {
            state.receptionist = true
        }
        if (payload.assocs.info.user_type === 'Administrador') {
            state.admin = true
        }
        if (payload.assocs.info.user_type === 'Monitor') {
            state.monitor = true
        }
    },

    updateAvatar: function(state, avatar) {
        state.avatar = avatar
    },

    logOut: function (state) {
        //  remove the token from storage
        localStorage.removeItem('token')

        state.access_token = null
        state.stagename = null
        state.avatar = null
        state.studio = false
        state.admin = false
        state.counter = false
        state.support = false
        state.receptionist = false
        state.monitor = false
    }
}

export default {
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js